import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TipiDannoFormComponent } from './dialogs/form/form.component';
import { TipiDannoRoutingModule } from './tipi-danno-routing.module';
import { TipiDannoComponent } from './tipi-danno.component';
import { CustomMaterialModule } from '../../material-module/material.module';
import { ResourcefulIndexModule } from '../../shared/resourceful-index/resourceful-index.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [TipiDannoComponent, TipiDannoFormComponent],
  imports: [
    CommonModule,
    TipiDannoRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
  ]
})
export class TipiDannoModule { }
